import { createContext, useContext } from 'react';
import { EditGroupMode } from '@models/Products';

export interface ProductAnalyzerGroupType {
  selectedModelGroups: string[];
  selectedModelsName: string[];
  selectModelGroup: (mg: string) => void;
  selectModelsName: (mg: string) => void;
  clearSelectedModelsGroup: () => void;
  isModelGroupSelected: (mg: string) => boolean;
  isCreateModalGroupPopUp: boolean;
  setIsCreateModalGroupPopUp: (value: boolean) => void;
  isShareModalGroupPopUp: boolean;
  setIsShareModalGroupPopUp: (value: boolean) => void;
  groupNameToBeDelete: string;
  setGroupNameToBeDelete: (groupName: string) => void;
  isDeleteModalGroupPopUp: boolean;
  setIsDeleteModalGroupPopUp: (value: boolean) => void;
  isEditGroupMode: EditGroupMode;
  setIsEditGroupMode: (editGroup: EditGroupMode) => void;
}

export const ProductAnalyzerGroupContext = createContext<ProductAnalyzerGroupType>({} as ProductAnalyzerGroupType);

export const useProductAnalyzerGroupEventState = (): ProductAnalyzerGroupType => {
  return useContext(ProductAnalyzerGroupContext);
};
